@if(gestures?.panEnabled){
<finxone-web-frontend-pan-reveal>
  <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>

  <!-- Left positioned actions -->
  <div class="d-flex" reveal-left>
    <ng-container>
      <span
        *ngFor="let actionBtn of actionButtonsLeft; let i = index; trackBy: trackByAction"
        [ngClass]="actionBtn.linkToGlobalStyling ? actionBtn.class : ''"
        (click)="onAction(actionBtn, $event)"
        [ngStyle]="actionBtn._style"
        [innerHTML]="renderHandlebarsTemplate(actionBtn.actionTitle) | safeHtml"
      >
      </span>
    </ng-container>
  </div>

  <!-- Right positioned actions (default or explicit 'right') -->
  <div class="d-flex justify-end" reveal-right>
    <ng-container>
      <span
        *ngFor="let actionBtn of actionButtonsRight; let i = index; trackBy: trackByAction"
        [ngClass]="actionBtn.linkToGlobalStyling ? actionBtn.class : ''"
        (click)="onAction(actionBtn, $event)"
        [ngStyle]="actionBtn._style"
        [innerHTML]="renderHandlebarsTemplate(actionBtn.actionTitle) | safeHtml"
      >
      </span>
    </ng-container>
  </div>
</finxone-web-frontend-pan-reveal>

} @else {
<ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
}

<ng-template #itemTemplate>
  <div
    [ngStyle]="textContentStyle"
    [class]="customClass"
    [innerHTML]="createTemplateData() | safeHtml"
    (click)="onItemClick()"
  ></div>
</ng-template>
